<template>
    <div class="result-bet">
        <div class="result--item" v-for="(r, i) in results" :key="i">
            <div class="result--item__infor">
                <div class="result--item__infor--first">
                    <p class="game-name">{{ getTranslatedText(r.gameName) }}</p>
                    <p class="pick">{{ getTranslatedText(r.marketName) }}</p>
                    <p class="draw-date">{{ renderDateTimeText(r.drawDate) }}</p>
                    <div class="list-number">
                        <template v-if="r.numbersConvert.length > 0">
                            <Number
                                :customClass="'number__in-list'"
                                v-for="(n, i) in r.numbersConvert"
                                :key="i"
                                :number="n.value"
                                :bgColor="n.color"
                            />
                        </template>
                        <p v-else>{{ getTranslatedText(r.marketOptionName) }}</p>
                    </div>
                </div>
                <div class="result--item__infor--after">
                    <p class="ref"> {{ getTranslatedText('bet ref') }} {{ r.reference }}</p>
                    <p class="odds">{{ getTranslatedText('odds') }} {{ formatPrice(+r.odds) }}</p>
                    <p class="stake"> {{ getTranslatedText('stake') }} {{ currencySymbol }} {{ formatPrice(+r.wager) }}</p>
                    <p v-if="r.numbersConvert.length > 0" class="save-number" @click="handleSaveMyNumber(r)">
                      {{ getTranslatedText('save to my number') }}
                    </p>
                </div>
            </div>
            <p class="result--item__drawdate" v-if="r.nextdrawsNumber">
                <span class="title">{{ getTranslatedText('next') }} {{ r.nextdrawsNumber }}: </span>
                <span v-for="(d, i) in r.nextDrawsData" :key="i">
                    <span class="index">{{ i + 1 }}</span> {{ renderDateTimeText(d.draw_date) }},&nbsp;
                </span>
            </p>
        </div>
    </div>
</template>
<script>
import utilsMixin from '@/mixins/function-utils';
import languageMixins from "@/mixins/language-mixins";
import Number from "@/components/common/number";
import EventBus from '@/utils/EventBus';
import { notifyApiError } from "@/utils/notify";
import myNumberService from "@/services/my-numbers/index.service.ts"
import { getStateStore } from "@/utils/utils.ts"

export default {
    mixins: [utilsMixin, languageMixins],
    components: { Number },
    data() {
        return {
            currencySymbol: ''
        }
    },
    props: {
        results: {
            type: Array
        }
    },
    created() {
        let { currency_symbol } = getStateStore().accountSetting;
        this.currencySymbol = currency_symbol;
    },  
    methods: {
        async handleSaveMyNumber(r) {
            try {
                const payload = {
                    market_options_id: r.pick,
                    numbers: r.numbers
                }
                let res = await myNumberService.saveMyNumber(payload);
                if (res.status == 'success') {
                    EventBus.emit('remove-result', r)
                    //emit to reload
                    EventBus.emit("reload-my-numbers")
                }
            } catch (error) {
                notifyApiError(error);
            }
        }
    }

}
</script>

<style lang="scss" scoped>
@import "@/public/scss/components/betslip/result.scss";
</style>
